// extracted by mini-css-extract-plugin
export default {"menuBlock":"hG-z","title":"iG-z","nav":"jG-z","flexCell":"kG-z","facetLink":"lG-z"};